<script>
    import JobCard from "@buhl_ui/buhl_core/bc_news/joboffercards/lib/jobcard/JobCard.svelte";

    let { jobCards, latitude, longitude, headline } = $props();
</script>

<!--als Anzeige in Nachricht-->
<div class="job-cards-container">
    {#if jobCards.length > 0}
        <h2 class="hp_headline-small mb-3">{headline}</h2>
        <div class="job-cards-wrapper overflow-auto">
            <div class="d-flex flex-nowrap gap-3 pb-2">
                {#each jobCards as job, i}
                    <div class="job-card-item flex-shrink-0">
                        <JobCard
                            title={job.title}
                            is_ship={job.is_ship}
                            company={job.company}
                            employment_mode={job.employment_mode}
                            category={job.trade_group}
                            location={job.city}
                            logo={job.company_logo}
                            url={job.url}
                            {latitude}
                            {longitude}
                            index={i}
                            layout="up"
                            title_count={75}
                            trancate_count={30}
                        />
                    </div>
                {/each}
            </div>
        </div>
    {:else}
        <p class="text-center py-3">Keine Stellenangebote gefunden.</p>
    {/if}
</div>

<style>
    .job-cards-container {
        float: right;
        width: 400px;
        margin-left: 10px;
        margin-bottom: 10px;
        transform: translate(90px, 5px);
    }

    .job-card-item {
        width: 400px;
        min-width: 320px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        .job-cards-container {
            transform: none; /* verschieben deaktivieren */
        }

        .job-card-item {
            width: 370px; /* passt sich automatisch an */
            min-width: auto; /* notwendig */
        }

        .job-cards-wrapper {
            overflow-x: auto; /* horizontales Scrollen bei Bedarf */
            -webkit-overflow-scrolling: touch;
        }
    }

    @media (max-width: 767px) {
        .job-cards-container {
            width: 350px; /* volle Breite auf Handy */
            float: none; /* float entfernen, unter Text */
            margin-left: 0; /* kein extra Abstand */
            transform: none; /* verschieben deaktivieren */
        }

        .job-card-item {
            width: 320px; /* passt sich automatisch an */
            min-width: auto; /* notwendig */
        }

        .job-cards-wrapper {
            overflow-x: auto; /* horizontales Scrollen bei Bedarf */
            -webkit-overflow-scrolling: touch;
        }
    }

    /* Schönere Scrollbar als klassik */
    .overflow-auto::-webkit-scrollbar {
        height: 8px;
    }

    .overflow-auto::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .overflow-auto::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
    }

    .overflow-auto::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
</style>
